import BreastFeedingWarning from './BreastFeedingWarning';

export default BreastFeedingWarning;
